import React, { useState, useRef } from 'react';
import clsx from 'clsx';
import { usePoster } from '../PosterContext';

const POSTER_SRC = "https://storage.googleapis.com/escape-bar-firebase.appspot.com/static/goty2024/poster4.png";
const POSTER_TITLE = "金剛石醫院";
const POSTER_DESC = "史詩巨作 最強卡司";

const VARIANT_SRC = "https://storage.googleapis.com/escape-bar-firebase.appspot.com/static/goty2024/poster4vv.jpg";
const VARIANT_DESC = "擇微覽幽 明察秋毫";

const PosterModal4 = ({ isOpen, onClose }) => {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0, relX: 0.5, relY: 0.5 });
  const [showMagnifier, setShowMagnifier] = useState(false);
  const imgRef = useRef(null);

  const { isGameEnabled } = usePoster();

  const handleMove = (clientX, clientY, target) => {
    if (!isGameEnabled) return;
    const rect = target.getBoundingClientRect();
    const x = clientX - rect.left;
    const y = clientY - rect.top;

    // 取得圖片實際顯示寬高
    const img = imgRef.current;
    if (!img) return;
    const naturalWidth = img.naturalWidth;
    const naturalHeight = img.naturalHeight;
    const containerWidth = rect.width;
    const containerHeight = rect.height;

    // 計算圖片顯示寬高和偏移
    const imgAspect = naturalWidth / naturalHeight;
    const containerAspect = containerWidth / containerHeight;
    let displayWidth, displayHeight, offsetX, offsetY;
    if (imgAspect > containerAspect) {
      displayWidth = containerWidth;
      displayHeight = containerWidth / imgAspect;
      offsetX = 0;
      offsetY = (containerHeight - displayHeight) / 2;
    } else {
      displayHeight = containerHeight;
      displayWidth = containerHeight * imgAspect;
      offsetY = 0;
      offsetX = (containerWidth - displayWidth) / 2;
    }

    // 計算滑鼠在圖片上的相對位置（0~1）
    const relX = Math.min(Math.max((x - offsetX) / displayWidth, 0), 1);
    const relY = Math.min(Math.max((y - offsetY) / displayHeight, 0), 1);

    setMousePosition({ x, y, relX, relY });
    setShowMagnifier(true);
  };

  const handleMouseMove = (e) => handleMove(e.clientX, e.clientY, e.currentTarget);
  const handleTouch = (e) => {
    const touch = e.touches[0];
    handleMove(touch.clientX, touch.clientY, e.currentTarget);
  };

  const handleMouseLeave = () => {
    setShowMagnifier(false);
  };

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-[2000] flex items-center justify-center transition-all"
      style={{
        backgroundImage: `url('/img/goty2024/hero-bricks.png')`,
        backgroundRepeat: 'repeat',
        backgroundColor: 'rgba(0,0,0,0.90)',
      }}
      onClick={onClose}
    >
      <button
        className="absolute top-4 right-4 text-white text-3xl font-bold z-60"
        onClick={(e) => { e.stopPropagation(); onClose(); }}
        aria-label="關閉"
      >
        ×
      </button>
      <div
        className="flex flex-col items-center justify-between relative"
        onClick={e => e.stopPropagation()}
      >
        <div
          className="w-[calc(100%+2rem)] md:w-[calc(100%+4rem)] bg-[#DFB750] text-center border-x-8 border-b-8 border-solid border-black mr-[-1rem] ml-[-1rem] md:mr-[-2rem] md:ml-[-2rem]"
        >
          <h2 className="text-2xl md:text-3xl font-bold tracking-wide text-black py-2 md:py-4">
            {POSTER_TITLE}
          </h2>
        </div>
        <div className="relative w-80 md:w-auto h-auto md:h-[75vh]">
          {isGameEnabled ? (
            <div 
              className="relative w-full h-full cursor-crosshair"
              onMouseMove={handleMouseMove}
              onTouchMove={handleTouch}
              onTouchStart={handleTouch}
              onMouseLeave={handleMouseLeave}
            >
              <img
                ref={imgRef}
                src={VARIANT_SRC}
                alt={POSTER_TITLE}
                className="object-contain w-full h-full mx-auto border-x-8 border-b-8 border-solid border-black shadow-2xl"
              />
              {showMagnifier && (
                <div 
                  className="absolute w-36 h-36 rounded-full border-4 border-white shadow-2xl overflow-hidden pointer-events-none z-10"
                  style={{
                    left: mousePosition.x + 24,
                    top: mousePosition.y - 144
                  }}
                >
                  <div 
                    className="w-full h-full"
                    style={{
                      backgroundImage: `url(${VARIANT_SRC})`,
                      backgroundSize: '2000% 2000%',
                      backgroundPosition: `${mousePosition.relX * 100}% ${mousePosition.relY * 100}%`
                    }}
                  />
                </div>
              )}
            </div>
          ) : (
            <img src={POSTER_SRC} alt={POSTER_TITLE} className="object-contain w-full h-full mx-auto border-x-8 border-b-8 border-solid border-black shadow-2xl" />
          )}
        </div>
        <div className="mt-6 text-center">
          <p className={clsx("text-xl md:text-2xl font-bold tracking-widest shadow-2xl", {
            'text-white': !isGameEnabled,
            'text-black': isGameEnabled
          })}>
            {isGameEnabled ? VARIANT_DESC : POSTER_DESC}
          </p>
        </div>
      </div>
    </div>
  );
};

export default PosterModal4;
